import React from 'react'
import * as S from './styled'
import type { FieldsetRowProps } from './types'

export const FieldsetRow = ({
  variant = 'medium',
  inner,
  noMargin = false,
  children,
}: FieldsetRowProps) => {
  return (
    <S.Container $variant={variant} $inner={inner} $noMargin={noMargin}>
      {children}
    </S.Container>
  )
}
